<template>
	<div id="app" style="max-width: 1168px; margin:0 auto">
		<div class="header max-contain">
			<div class="log">
				<img id="header-img" src="../assets/img/logo.png" />
				<!-- <div class="company_name">华冠科技</div> -->
			</div>
			<div id="menu_index">
				<el-menu
					:default-active="activeIndex"
					class="el-menu-demo"
					menu-trigger="click"
					text-color="#404041"
					style="height: 65px; border:0;"
					mode="horizontal"
					@select="handleSelect"
				>
					<el-menu-item index="/" class="header-title">HOME</el-menu-item>
					<el-menu-item index="/about" class="header-title">ABOUT</el-menu-item>
					<el-menu-item index="/product" class="header-title">PRODUCTS</el-menu-item>
					<el-menu-item index="/partner" class="header-title">PEOPLE</el-menu-item>
					<el-menu-item index="/connect" class="header-title">CONTACT</el-menu-item>
				</el-menu>
			</div>
		</div>
		<div class="container" style="clear: both;">
			<router-view></router-view>
		</div>

		<!-- <div class="footer">
            <div class="footer-item">
                <div class="title">联系我们</div>
                <div class="line"></div>
                <svg class="icon" width="24px" height="24px" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="#797979"
                        d="M739.0208 485.376a26.624 26.624 0 1 0 52.736-8.192 269.4144 269.4144 0 0 0-244.1728-241.664 26.7264 26.7264 0 1 0-2.0992 53.3504c1.6384 0.1024 164.7104 8.704 193.536 196.4544z m59.5456-254.7712C616.96 48.9472 451.1744 112.6912 444.2624 115.5072a26.7264 26.7264 0 0 0 19.8656 49.5616c1.3824-0.5632 139.776-53.7088 296.704 103.3216 144.5888 144.64 102.144 291.4816 100.352 297.5744a26.7264 26.7264 0 0 0 50.8928 15.9744c2.304-7.424 54.784-182.9888-113.5104-351.3344z m-62.464 629.0432c-2.56 2.56-10.9056 8.5504-33.536 8.5504-73.3184 0-213.8624-61.696-349.184-197.0688-177.6128-177.8176-217.9584-353.3824-188.3136-383.0272 19.1488-19.2512 59.0336-59.1872 96.768-59.1872 20.8384 0 40.6528 12.032 60.416 36.7616 57.088 71.168 32.3584 95.5392-8.6016 135.9872l-7.5776 7.5264c-10.24 10.24-15.7184 23.808-15.7184 39.168 0 24.576 11.8272 68.9664 114.2784 171.4688 102.5024 102.5024 146.8928 114.3296 171.3664 114.3296 15.36 0 28.8256-5.376 39.0656-15.616l7.5264-7.5776c22.272-22.6304 41.5232-42.1376 65.8432-42.1376 18.8928 0 42.496 11.264 70.144 33.4848 23.5008 18.944 35.4816 37.7856 36.5056 57.5488 2.1504 38.7072-39.1168 79.9744-58.9824 99.84z m-47.616-244.224c-46.6944 0-77.056 30.8224-103.8848 58.0096l-8.6016 7.3216c-8.192 0-42.0352-7.1168-133.632-98.7136C335.5136 475.136 343.808 446.976 343.808 446.976l7.3216-7.3216c42.1888-41.6256 99.9424-98.6624 12.8-207.4112-30.208-37.632-64.512-56.7296-102.0928-56.7296-59.8016 0-108.4416 48.64-134.5024 74.752-77.1584 77.312 35.7888 305.8688 188.3648 458.6496C462.4896 855.8592 615.7312 921.6 702.5664 921.6c31.2832 0 55.296-8.192 71.2704-24.1664 25.2928-25.2928 77.9264-77.9776 74.5472-140.4416-1.8944-35.328-20.8896-67.7376-56.4224-96.3072-37.888-30.464-71.7824-45.2608-103.5264-45.2608z" />
                </svg>
                <span style="color:#797979">020-89888060</span>
                <svg class="icon" width="24px" height="24px" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="#797979"
                        d="M960 804.096c0 43.072-34.88 78.016-77.888 78.016L297.728 882.112c-43.008 0-77.952-34.944-77.952-78.016L219.776 414.592c0-13.184 3.584-25.344 9.344-36.224L224.128 373.312c5.056-12.48 14.336-22.656 25.984-29.12l5.184 5.184C267.52 341.44 282.048 336.704 297.728 336.704l584.384 0c15.616 0 30.272 4.736 42.368 12.736l5.248-5.184c11.648 6.464 20.928 16.64 25.92 29.12l-4.992 5.056C956.416 389.248 960 401.408 960 414.592L960 804.096zM882.112 375.68 297.728 375.68c-4.8 0-9.344 0.96-13.632 2.56l278.272 278.272c15.232 15.168 39.872 15.168 55.104 0l278.272-278.272C891.52 376.64 886.848 375.68 882.112 375.68zM921.024 414.592c0-2.048-0.256-4.032-0.576-5.952l-275.456 275.392c-30.4 30.528-79.744 30.528-110.208 0L259.392 408.576c-0.32 1.984-0.64 3.968-0.64 6.016l0 389.504c0 21.568 17.408 38.976 38.976 38.976l584.384 0c21.504 0 38.848-17.408 38.848-38.976L920.96 414.592zM765.248 219.84c0-2.048-0.384-4.032-0.64-6.016l-83.904 83.904L625.6 297.728l114.24-114.304c-4.224-1.6-8.768-2.56-13.632-2.56l-584.32 0c-4.8 0-9.344 0.96-13.632 2.56L242.56 297.728 187.456 297.728 103.552 213.824C103.232 215.808 102.976 217.728 102.976 219.84l0 389.568c0 21.504 17.408 38.976 38.912 38.976l38.976 0 0 38.912L141.888 687.296C98.88 687.296 64 652.352 64 609.344L64 219.84c0-13.184 3.584-25.344 9.344-36.224L68.288 178.56c5.056-12.48 14.272-22.656 25.984-29.12l5.184 5.184c12.224-8 26.752-12.736 42.432-12.736l584.32 0c15.744 0 30.272 4.736 42.496 12.736l5.12-5.184c11.712 6.464 20.992 16.64 25.984 29.12L794.88 183.616c5.76 10.88 9.344 23.04 9.344 36.224l0 77.888-38.912 0L765.312 219.84z" />
                </svg>
                <span style="color:#797979">@yangze.net</span>
            </div>
            <div class="footer-item">
                <div>营业时间 </div>
                <div class="line"></div>
                <svg class="icon" width="24px" height="24px" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill="#797979"
                        d="M512 97.52381c228.912762 0 414.47619 185.563429 414.47619 414.47619s-185.563429 414.47619-414.47619 414.47619S97.52381 740.912762 97.52381 512 283.087238 97.52381 512 97.52381z m0 73.142857C323.486476 170.666667 170.666667 323.486476 170.666667 512s152.81981 341.333333 341.333333 341.333333 341.333333-152.81981 341.333333-341.333333S700.513524 170.666667 512 170.666667z m36.571429 89.697523v229.86362h160.865523v73.142857H512a36.571429 36.571429 0 0 1-36.571429-36.571429V260.388571h73.142858z" />
                </svg>
                <span class="text">周一到周日9:00-23:00</span>
            </div>
        </div> -->
		<div class="bottom">
			@2024 All Copyright Reserved By https://norja.yangze.net/
		</div>
	</div>
</template>

<script>
export default {
	name: 'Layout',
	data() {
		return {
			activeIndex: '/',
		};
	},
	watch: {
		$route() {
			this.setCurrentRoute();
		},
	},
	methods: {
		handleSelect(path) {
			this.$router.push({ path });
		},
		setCurrentRoute() {
			this.activeIndex = this.$route.path; // 通过他就可以监听到当前路由状态并激活当前菜单
		},
	},
	created() {
		this.setCurrentRoute();
	},
};
</script>

<style lang="less" scoped>
.el-menu-demo {
	background: transparent !important;
	display: flex;
	flex-wrap: nowrap;
}

.el-menu--horizontal > .el-menu-item {
	border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
	border-bottom: none;
	border-top: 2px solid #f26551;
	color: #f26551;
}

.el-menu-item {
	padding: 0;
	margin: 0 35px;

	&:hover {
		background-color: transparent !important;
	}
}

.el-menu-item:focus,
.el-menu-item:hover {
	background-color: transparent !important;
	border: none;
}

.header-title {
	font-size: 14px;
	font-weight: 700;
	text-transform: uppercase;
	// line-height: 22px;
	letter-spacing: 1.8px;
}

.company_name {
	font-weight: normal;
	font-size: 18px;
	color: #fff;
}

#menu_index {
	float: left;
	height: 100%;
}

.header {
    width: 100%;
    height: 65px;
    // background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items:center;
    justify-content: center;
    border-bottom: 1px solid #edecec;
    background-color: #fff;
}

.log {
	width: 200px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;

    #header-img {
        width: 104px;
        height: 50px;
    }
}

// .footer {
//     display: flex;
//     align-items: center;
//     justify-content: space-evenly;
//     width: 100%;
//     height: 84px;
//     background-color: #283340;
//     color: #fff;
//     font-size: 14px;

//     .footer-item {
//         display: flex;
//         align-items: center;
//     }

//     .line {
//         height: 32px;
//         width: 1px;
//         background-color: #fff;
//         margin-left: 20px;
//     }

//     .text {
//         font-size: 12px;
//         color: #868686;
//         margin-right: 20px;
//     }

//     svg {
//         margin: 0 20px;
//     }
// }

.bottom {
	height: 40px;
	background: #1f2127;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	color: #868686;
}

a {
	text-decoration: none;
}

a:visited {
	text-decoration: none;
}

a:hover {
	text-decoration: none;
}

a:active {
	text-decoration: none;
}
</style>
